import 'reflect-metadata';
import ServiceErrorDescriptor from './ServiceErrorDescriptor.js';
export const RegisterServiceError = (data) => function (target) {
    ServiceErrorDescriptor.register(target, data);
};
//# sourceMappingURL=decorators.js.map